import { render, staticRenderFns } from "./SoliForm.vue?vue&type=template&id=6e8517aa&scoped=true"
import script from "./SoliForm.vue?vue&type=script&lang=js"
export * from "./SoliForm.vue?vue&type=script&lang=js"
import style0 from "./SoliForm.vue?vue&type=style&index=0&id=6e8517aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8517aa",
  null
  
)

export default component.exports